import { SWATCH_NA } from "@/constants";
import { getSwatchPreset } from "@/services/server/plpHelper";

export const getBadgesData = (product, configdata = {}) => {
  const plpBadges = getdefaultBades(configdata?.plpBadgeList);
  const abc = plpBadges.filter(item => {
    const isNew =
      item.key.includes("new") && showNewBadge(product.shipmentDate);
    const isSale = item.key.includes("sale") && !_isEmpty(product.badgeValue);
    const is3D = item.key.includes("3d") && isThreeDBadgeAvailable(product);
    const isExclusive =
      item.key.includes("exclusive") &&
      (parseToBoolean(product.productIsExclusive) ||
        parseToBoolean(product?.["ProductIsExclusive_s"]));
    const isSet =
      item.key.includes("bundleBadge") &&
      (product.bundleFlag === "Yes" || product.Bundle_s === "Yes");
    return isNew || isSale || is3D || isExclusive || isSet;
  });
  return abc;
};

export const colorFetcheslogic = (data, width, swatchUrl) => {
  let colorsTemp = [];
  if (data.colors) {
    colorsTemp = data.colors.map(color => {
      const d = color?.split("|");
      // Use desktop preset for server-side rendering
      const preset = getSwatchPreset(width);
      const imgURL = `${swatchUrl}${d[1]}${preset}`;
      const imgObj = { src: imgURL, alt: d[0] };
      const colorObj = {
        colorName: d[0],
        title: d[0],
        image: imgObj,
        shape: "square",
        size: "small",
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        isDiscontinued: d[4],
        customerFacingSKU: d[5],
        id: d[2],
        // All event handlers will be attached client-side
        onMouseEnter: null,
        onMouseLeave: null,
        productData: {
          sku: d[2],
          customerFacingSKU: d[5],
          image: imgURL,
          colorName: d[0],
          isStock: d[3],
        },
      };
      return colorObj;
    });
  }

  const colorsTempVal = colorsTemp.filter(
    item =>
      item.swatch?.toLowerCase() !== SWATCH_NA.toLowerCase() &&
      (item.isDiscontinued === "false" ||
        Date.parse(item.isDiscontinued) > Date.now())
  );
  return colorsTempVal;
};

const isThreeDBadgeAvailable = data => {
  return (
    data["resourceNvznId"] ||
    data["resourceVntanaProductId"] ||
    data["resourceVntanaProductIdList"]?.length ||
    data["resourceNvznIdList"]?.length
  );
};

export const getBadgeValue = (key, arry) => {
  const badgeInfo = arry.find(item => item.map.Key === key);
  const {
    map: { Key = "", Values: { myArrayList: badgeValue = [] } = {} } = {},
  } = badgeInfo;
  return {
    key: Key,
    value: badgeValue[0] ?? "",
  };
};

const getdefaultBades = (plpBadgeList = []) => {
  const displayOrderBadges =
    plpBadgeList.find(item => item.map.Key === "displayOrderBadges") ?? {};
  const {
    map: { Values: { myArrayList: displayOrderBadgeList = [] } = {} } = {},
  } = displayOrderBadges;

  const plpBadges = [];
  displayOrderBadgeList.forEach(item => {
    const badgeData = getBadgeValue(item, plpBadgeList);
    plpBadges.push({ label: badgeData.value, key: badgeData.key }); // variant:badgeData.key,
  });
  return plpBadges;
};

export const getPlpProcessedData = async (inputObj = {}) => {
  const newData = {};
  // First process raw data
  const { total = 0 } = inputObj || {};
  newData.total = total;
  Object.entries(inputObj).forEach(([key, value]) => {
    if (Array.isArray(value) && key === "data") {
      newData.data = value.map(item => {
        // Extract productName logic
        const productName = item?.["productName_s"] || "";
        const colors = item?.["Color.SKU.Details_ss"];

        // 1) Destructure everything you use from `item`
        const {
          ProductDescriptionProductShort_s: productShortDescription = "",
          sku_s: sku,
          masterSKU_s: masterSKU = null,
          slug_s: slug = null,
          ProductProductNo_s: productNo = null,
          Product_Category: productCategory = "",
          ProductCategory_s: productLocalCategory_s = "",

          ProductBrandNameDisplay_s: productBrandNameDisplay = "",
          // images
          "productImages.labelWithUrl_ss": productImagesLabelWithUrlSS = [],
          "productImages.url_s": productImageUrl = "",
          "productImages.url_ss": productImagesUrlSS = [],
          "productImage.url_ss": productSingleImageUrl = [],
          CustomerFacingSKU_s: customerFacingSKU = "",
        } = item ?? {};
        return {
          originalData: item,
          description: productShortDescription,
          colors: colors,
          slug,
          productNo,
          productName: productName ?? null,
          category: productCategory || productLocalCategory_s,
          productCollectionsName: productBrandNameDisplay,
          productVariantImages: productImagesLabelWithUrlSS,
          sku: sku ?? masterSKU,
          productCategory,
          productImageUrl,
          productImagesUrlSS,
          masterSKU,
          productSingleImageUrl,
          customerFacingSKU,
        };
      });
    }
  });
  return {
    ...newData,
  };
};
